import { render, staticRenderFns } from "./PushBox.vue?vue&type=template&id=24113d1b&"
import script from "./PushBox.vue?vue&type=script&lang=js&"
export * from "./PushBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports